import { render, staticRenderFns } from "./TwoLvlAccordion.vue?vue&type=template&id=856cc876&scoped=true&"
import script from "./TwoLvlAccordion.vue?vue&type=script&lang=js&"
export * from "./TwoLvlAccordion.vue?vue&type=script&lang=js&"
import style0 from "./TwoLvlAccordion.vue?vue&type=style&index=0&id=856cc876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856cc876",
  null
  
)

export default component.exports